import styled from 'styled-components'

export const ConferenceAtendees = styled.div`
  display: flex;
  margin-left: 5px;
`
